import uiLocale from '../../../utils/UILocale.js';

export default {
  title: uiLocale.getString('component.tradeUp.title')
    ? uiLocale.getString('component.tradeUp.title') : 'Similar products to compare',
  actualHeader: uiLocale.getString('component.tradeUp.actual_header')
    ? uiLocale.getString('component.tradeUp.actual_header') : 'You are viewing',
  higherSpinSpeedHeader: uiLocale.getString('component.tradeUp.higher_spin_speed_header')
    ? uiLocale.getString('component.tradeUp.higher_spin_speed_header') : 'Need higher spin speed?',
  moreCapacityHeader: uiLocale.getString('component.tradeUp.more_capacity_header')
    ? uiLocale.getString('component.tradeUp.more_capacity_header') : 'Need more capacity?',
  reviewsParameter: uiLocale.getString('component.tradeUp.reviews_parameter')
    ? uiLocale.getString('component.tradeUp.reviews_parameter') : 'Reviews',
  addToBasket: uiLocale.getString('component.tradeUp.add_to_basket')
    ? uiLocale.getString('component.tradeUp.add_to_basket') : 'Add to basket',
  buttonCompareText: uiLocale.getString('component.tradeUp.compare_button_text')
    ? uiLocale.getString('component.tradeUp.compare_button_text') : 'See all specs and compare'
};
